import axios from 'axios'
import store from "@/store";

const NOTIFICATIONS = 'notifications';
const ROUTE_NOTIFICATIONS = `/rest/v4/${NOTIFICATIONS}`;

export default {
  getAll() {
    return axios.get(`${ROUTE_NOTIFICATIONS}`)
  },
  getUnread() {
    return axios.get(`${ROUTE_NOTIFICATIONS}`,{params: {read: false, page: 0, size: 10, sort: 'createdAt:desc'}})
  },
  async updateUnreadNotificationsCount() {
    let response = await axios.get(`${ROUTE_NOTIFICATIONS}/unreadCount`)
    store.commit('badgeCounter/setUnreadNotificationsCount', response?.data ?? 0);
  },
  getById(id) {
    return axios.get(`${ROUTE_NOTIFICATIONS}/${id}`);
  },
  async setRead(id) {
    await axios.patch(`${ROUTE_NOTIFICATIONS}/${id}/readAt`);
    this.updateUnreadNotificationsCount();
  },
  async setUnread(id) {
    await axios.patch(`${ROUTE_NOTIFICATIONS}/${id}/unread`);
    this.updateUnreadNotificationsCount();
  },
  async delete(id) {
    await axios.delete(`${ROUTE_NOTIFICATIONS}/${id}`);
    this.updateUnreadNotificationsCount();
  },

}
